import { render, staticRenderFns } from "./YourYagi.vue?vue&type=template&id=3a78189a"
import script from "./YourYagi.vue?vue&type=script&setup=true&lang=ts"
export * from "./YourYagi.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports